if (!customElements.get('syun-hero-slider')) {
  customElements.define('syun-hero-slider', class SyunHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 5000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.paused = false;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1, true));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true)));
      this.querySelector('[data-toggle]')?.addEventListener('click', () => this.toggle());
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());
      this.start();
    }
    show(nextIndex, announce) {
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelectorAll('a, button').forEach((item) => active ? item.removeAttribute('tabindex') : item.setAttribute('tabindex', '-1'));
      });
      this.dots.forEach((dot, index) => {
        const active = index === this.index;
        dot.classList.toggle('is-active', active);
        active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current');
      });
      if (announce) {
        const status = this.querySelector('[data-status]');
        if (status) status.textContent = `スライド${this.index + 1} / ${this.slides.length}`;
      }
      this.restart();
    }
    start() {
      if (!this.autoplay || this.paused || this.reduceMotion || document.hidden || this.timer) return;
      this.timer = window.setInterval(() => this.show(this.index + 1, false), this.interval);
    }
    stop() { window.clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }
    toggle() {
      this.paused = !this.paused;
      const toggle = this.querySelector('[data-toggle]');
      toggle.textContent = this.paused ? '再生' : '停止';
      toggle.setAttribute('aria-label', this.paused ? '自動切替を再開' : '自動切替を停止');
      this.paused ? this.stop() : this.start();
    }
  });
}
